import { createNodeFrom } from "@/models/nodes/createNodeFrom";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel, SerializedNode } from "@/models/nodes/types";
import type { NodeJson } from "@corca/data";

// TODO: validate with schema
export function isNodeJson(obj: unknown, options: { ignoreId: boolean }): obj is NodeJson {
  const isObject = typeof obj === "object" && obj !== null;
  if (!isObject) {
    return false;
  }
  const hasValidId = options.ignoreId || ("id" in obj && typeof obj.id === "string");
  const hasValidType = "type" in obj && typeof obj.type === "string";
  const hasValidProps = "props" in obj && typeof obj.props === "object" && obj.props !== null;
  const hasValidChildren =
    "children" in obj &&
    Array.isArray(obj.children) &&
    obj.children.every((n) => isNodeJson(n, options));
  return hasValidId && hasValidType && hasValidProps && hasValidChildren;
}

export function nodeFromJson(
  doc: DocumentModel,
  node: SerializedNode | NodeJson,
  options?: { resetIds: boolean },
): NodeModel | null {
  return createNodeFrom(node, doc, options);
}
